export default __webpack_public_path__ + "static/media/Logo Myracle Rosso flat.00c72c75.svg";